export default __webpack_public_path__ + "static/media/white-logo.235f5b02.png";